import { z } from 'zod';

export const WORKSPACE_NAME_MAX_LENGTH = 100;
export const WORKSPACE_DESCRIPTION_MAX_LENGTH = 500;

// Workspace validation schema
export const workspaceSelectionSchema = z.object({
  workspaceName: z
    .string()
    .min(1, 'Workspace name is required')
    .min(2, 'Workspace name must be at least 2 characters')
    .max(
      WORKSPACE_NAME_MAX_LENGTH,
      `Workspace name must be at most ${WORKSPACE_NAME_MAX_LENGTH} characters`,
    )
    .regex(
      /^[a-zA-Z0-9\s\-_]+$/,
      'Workspace name can only contain letters, numbers, spaces, hyphens, and underscores',
    )
    .refine((name) => name.trim().length > 0, 'Workspace name cannot be only whitespace'),
  workspaceDescription: z
    .string()
    .max(
      WORKSPACE_DESCRIPTION_MAX_LENGTH,
      `Workspace description must be at most ${WORKSPACE_DESCRIPTION_MAX_LENGTH} characters`,
    )
    .optional(),
});
